import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=6c4bcc10&scoped=true&"
import script from "./Headline.vue?vue&type=script&lang=ts&"
export * from "./Headline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4bcc10",
  null
  
)

export default component.exports